import { render, staticRenderFns } from "./area-report.component.vue?vue&type=template&id=41f89ecd&scoped=true"
import script from "./area-report.component.ts?vue&type=script&lang=ts&external"
export * from "./area-report.component.ts?vue&type=script&lang=ts&external"
import style0 from "./area-report.component.vue?vue&type=style&index=0&id=41f89ecd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f89ecd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f89ecd')) {
      api.createRecord('41f89ecd', component.options)
    } else {
      api.reload('41f89ecd', component.options)
    }
    module.hot.accept("./area-report.component.vue?vue&type=template&id=41f89ecd&scoped=true", function () {
      api.rerender('41f89ecd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-location-form/area-report/area-report.component.vue"
export default component.exports